module.exports = __webpack_public_path__ + "static/img/vector-smart-objects.4a19f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vector-smart-objects.png
// module id = DgMM
// module chunks = 0